const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/$lang/editorial/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/$lang/editorial/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { EDITORIAL_HUB_FAMILIES } from "@/features/editorial-hub/editorial-hub-families";
import { buildEditorialHubHead } from "@/features/editorial-hub/editorial-hub-head";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/$lang/editorial/")({
  loaderDeps: () => ({}),
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: async ({
    match,
    loaderData
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "editorialHub"
    });
    const landingT = createTranslator({
      locale,
      messages,
      namespace: "featurePageLanding"
    });
    return await buildEditorialHubHead({
      locale,
      title: t("metaTitle"),
      description: t("metaDescription"),
      landings: loaderData?.landings ?? [],
      families: EDITORIAL_HUB_FAMILIES.map(family => ({
        family,
        title: landingT(`${family}.title`),
        description: landingT(`${family}.description`)
      }))
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});